import { h, Component } from 'preact';
import { joinClasses } from 'utils/utils';
import HTML from 'components/core/html/html';
import Button from 'components/bolt/button/NTLiveButton';
import Store from 'store/store';
import 'store/bolt/signupBanner';
import s from 'components/bolt/signupBanner/signupBanner.sss';

export default class SignupBanner extends Component {
	constructor(props) {
		super(props);

		this.state = {
			show: this.props.show
		};

		this.closeBanner = this.closeBanner.bind(this);
		this.dropCookie = this.dropCookie.bind(this);
	}

	componentDidUpdate(prevProps) {
		if (prevProps.show !== this.props.show) {
			this.setState({ show: this.props.show });
		}
	}

	closeBanner() {
		this.props.close();
	}

	dropCookie(signup) {
		this.closeBanner();
		const duration = signup ? 182 : 1;
		const currentDate = Date.now();
		let expiryDate = new Date(currentDate);
		expiryDate.setDate(expiryDate.getDate() + duration);

		Store.emit('DROP_SIGNUP_COOKIE', expiryDate);
		Store.emit('POWSTER_GA_EVENT_TRACK', 'popup-' + Store.get().activePage.id, 'signup', signup ? 'signup' : 'dismiss');
	}

	render({ data = {}, client }, { show }) {
		let { title, blurb, button = {}, close = {} } = data;

		button = { type: 'signup', target: '_blank', ...button };

		return (
			<aside class={joinClasses(s.container, show && s.show)} ariaHidden={!show}>
				<div class={s.signupIcon} />
				<div class={s.content}>
					<div class={s.info}>
						<HTML class={s.title} tag='h3' markdown>{title}</HTML>
						<HTML class={s.blurb} tag='p' markdown>{blurb}</HTML>
					</div>
					<Button
						data={button}
						extraClass={s.signupBtn}
						client={client}
						onClick={this.dropCookie.bind(true, true)}
					/>
				</div>
				<button
					class={s.closeBtn}
					ariaLabel={close.ariaLabel}
					title={close.title}
					onClick={this.dropCookie.bind(true, false)}
				>
					<img class={s.icon} src={close.icon.src} alt={close.icon.alt} />
				</button>
			</aside>
		);
	}
}
